import { render, staticRenderFns } from "./PageConfiguration.vue?vue&type=template&id=704874ec&scoped=true&"
import script from "./PageConfiguration.vue?vue&type=script&lang=js&"
export * from "./PageConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704874ec",
  null
  
)

export default component.exports